"use client";

import { useTranslations } from "next-intl";
import { FC } from "react";

import ContactForm from "@/components/ContactForm/ContactForm";
import Image from "@/components/ui/Image/Image";
import { ContactFormProps } from "@/types";

const ContactFormComponentClient: FC<ContactFormProps> = ({ entry }) => {
  const t = useTranslations();

  return (
    <>
      <div className="w-full h-dvh relative overflow-scroll max-h-[100dvh]" id={entry?.type}>
        <Image
          src={entry.backgroundImage.url}
          width={1366}
          height={680}
          className="shadow aspect-3-2 object-cover w-full h-full"
          alt={entry.backgroundImage.title}
        />
        <div className="mx-m md:mx-auto w-[calc(100%-32px)] md:w-[40%] absolute md:left-[50%] top-[50%] md:-translate-x-1/2 -translate-y-1/2 rounded-2xl backdrop-blur-xl box-material-primary p-m">
          <div className="font-primary uppercase text-white font-normal text-l leading-6 tracking-widest text-center p-m">
            {t("contactform.title")}
          </div>
          <div className="font-secondary text-white text-s p-l pt-0 text-center">{t("contactform.subtitle")}</div>
          <ContactForm leadFormPageLocation={entry?.leadFormPageLocation ?? "Offer Page Lead Form"} />
        </div>
      </div>
    </>
  );
};

export default ContactFormComponentClient;
